import React from 'react'

interface PublicLayoutProps {
  children: React.ReactNode
}

export function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <h1 className="text-xl font-bold text-missionSolar-primaryTeal">
              Mission Solar
            </h1>
          </div>
          <nav className="flex items-center space-x-4">
            <a href="/auth/login" className="text-sm hover:underline">
              Anmelden
            </a>
          </nav>
        </div>
      </header>
      <main className="container mx-auto px-4 py-8">
        {children}
      </main>
    </div>
  )
}